<template>
    <Modal v-model="show" :mask-closable="false">
        <div slot="header" class="modal-header">设备详情</div>
        <div class="room-t">
            <div class="mr60">
                <span>房间号：</span><span>{{roomnumber}}</span>
            </div>
            <div>
                <span>房间状态：</span><span>{{roomstatuscn}}</span>
            </div>
        </div>
        <ul class="modal-list mt36">
            <li>
                <span>设备状态：</span><span :class="{'online':details.deviceStatus === 1,'offline':details.deviceStatus === 2}">{{details.deviceStatusCn}}</span>
            </li>
            <li>
                <span>设备类型：</span><span>{{devicetypecn}}</span> 
            </li>
            <li>
                <span>付费模式：</span><span>{{details.paymentTypeCn}}</span> 
            </li>
            <li v-if="details.paymentType === 1">
                <span>设备示数：</span><span>{{details.showReading + details.unit}}</span> 
            </li>
            <li v-else>
                <span>设备余额：</span><span>{{details.showReading+ details.unit}}</span> 
            </li>
            <li>
                <span>示数更新时间：</span><span>{{details.updateTime}}</span> 
            </li>
        </ul>
    </Modal>
</template>
 
<script type="text/ecmascript-6">
import { getDetails } from "api/meterRecharge";
export default {
    props: {
        n:{
            type:Number,
            default:0
        },
        roomid:{
           type:String,
           default:"" 
        },
        devicetype:{
            type:Number,
            default:null
        },
        devicetypecn:{
            type:String,
            default:'',
        },
        roomnumber:{
            type:String,
            default:'',
        },
        roomstatuscn:{
            type:String,
            default:'',
        },
        unit:{
            type:String,
            default:''
        }
    },
    watch: {
        n(val) {
            this.initData();
        }
    },
    data () {
        return {
            show:false,
            details:{
                roomNumber:'', //房间号
                deviceStatusCn:'', //设备状态
                roomStatusCn:'', //房间状态
                deviceTypeCn:'', // 设备类型
                paymentType:'', // 付费模式
                paymentTypeCn:'', //付费模式名称
                showReading:'', // 设备示数/设备余额
                updateTimeCn:'', // 示数更新时间

            }
        }
    },
    methods: {
        initData() {
            this.clear();
            getDetails({roomId:this.roomid,deviceType:this.devicetype}).then(res => {
                this.details = res.data;
                console.log(this.details)
                this.show = true;
            })
        },
        clear(){
            Object.keys(this.details).forEach(item => {
                this.details[item] = '';
            })
        }
    }
}
</script>
 
<style lang="css" scoped>
.room-t{
    border-bottom: 1px solid #F4F4F4;
    padding-bottom: 24px;
    font-size: 0;
}
.room-t>div,.room-t span{
    display: inline-block;
}
.room-t span{
    font-family: 'PingFangSC-Medium';
    font-size: 12px;
}
</style>